import axios from 'axios';

const SERVER = (process.env.REACT_APP_SERVER || '').replace(/\/$/, '');

// 관리자 아이디·비밀번호로 로그인하고 { accessToken, ... }을 돌려준다.
export async function requestAdminLogin(username, password) {
    const { data } = await axios.post(`${SERVER}/admin/api/login`, { username, password }, { withCredentials: true, timeout: 45000 });
    return data;
}

// refresh 쿠키로 관리자 토큰을 재발급받는다.
export async function requestAdminRefresh() {
    const { data } = await axios.post(`${SERVER}/admin/api/refresh`, {}, { withCredentials: true, timeout: 45000 });
    return data;
}
